import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';

import { WithColor } from '@styles/colors';
import Svg from '@styles/icons/svg';

import type { NcFileListItem, MessageStorage, SendStatusState, ScaleFontProps } from '@components/search/operations/components/StartJobPopup/types';
import { SEND_STATUS } from '@helpers';
import SendStatus from '@components/search/operations/components/StartJobPopup/components/SendStatus';
import { SEND_STATUS_CELL_HEIGHT } from '@components/search/operations/components/StartJobPopup/components/SendStatus/constants';

type SendToMachineCellProps = WithColor &
  Required<ScaleFontProps> & {
    element: NcFileListItem;
    status: SendStatusState;
    isThisFinish: boolean;
    messageStorage: MessageStorage;
    onSend: (element: NcFileListItem) => void;
  };

// Renders the per-NC-file row value: empty spacer when finished, the send status, or the (re)send button.
const SendToMachineCell = ({ element, status, isThisFinish, messageStorage, onSend, C, scale, font }: SendToMachineCellProps) => {
  const isError = status === SEND_STATUS.Error;

  if (isThisFinish) {
    return <View style={{ height: scale(SEND_STATUS_CELL_HEIGHT) }} />;
  }

  return status && !isError ? (
    <SendStatus status={status} id={element.ncFileId} messageStorage={messageStorage} C={C} scale={scale} font={font} />
  ) : (
    <View
      style={{
        flexDirection: 'row',
        gap: scale(15),
        alignItems: 'center',
        backgroundColor: C('Background/Light/Field on modal'),
      }}
    >
      {isError && (
        <View>
          <Text style={[font['Button 2'], { color: C('Label/Light/Warning') }]}>
            {i18n.t(messageStorage[element.ncFileId] || 'Error during sending file to machine')}
          </Text>
        </View>
      )}
      <TouchableElement onPress={() => onSend(element)}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              boxStyle,
              {
                backgroundColor: C(pressHoverColor('Button/Light/Primary')),
                paddingHorizontal: scale(13),
                borderRadius: scale(15),
                flexDirection: 'row',
                alignItems: 'center',
                height: scale(SEND_STATUS_CELL_HEIGHT),
              },
            ]}
          >
            <Svg icon="arrow" width={scale(8)} height={scale(7)} color="Button/Light/Primary Text" style={{ transform: [{ rotate: '180deg' }] }} />
            <View style={{ marginLeft: scale(4) }}>
              <Svg icon="sendToMachine" width={scale(19)} height={scale(15)} color="Button/Light/Primary Text" />
            </View>
            <Text style={[font['Button 2'], { color: C('Button/Light/Primary Text'), marginLeft: scale(10) }]}>
              {i18n.t(isError ? 'Retry Send To Machine' : 'Send To Machine')}
            </Text>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default SendToMachineCell;
